import { FC } from "react";
import { useTranslation } from "react-i18next";

/**
 * Terminal landing page for an authenticated user who holds no recognised
 * role. It is deliberately NOT wrapped in a role-gated ProtectedRoute: it is
 * where ProtectedRoute sends denials, so gating it would make the redirect
 * recurse into itself forever.
 */
const NoAccess: FC = () => {
  const { t } = useTranslation();
  return (
    <div className="container">
      <div className="row error-page align-items-center">
        <div className="error-page-content col-12">
          <h1>{t("No access rights")}</h1>
          <p>
            {t(
              "Your account does not have any access rights assigned yet, so there is nothing here to show you."
            )}
          </p>
          <p>
            {t(
              "Please contact your administrator to have the right permissions granted to your account."
            )}
          </p>
        </div>
      </div>
    </div>
  );
};

export default NoAccess;
